function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "24",
  height: "28"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.813 14.127c0 7.43 5.826 13.494 13.143 13.839a13.718 13.718 0 009.854-3.51c-1.617 1.077-3.508 1.696-5.53 1.696-3.286 0-6.23-1.636-8.21-4.217-1.525-1.808-2.514-4.482-2.58-7.482v-.652c.066-3 1.055-5.674 2.58-7.482 1.98-2.58 4.924-4.217 8.21-4.217 2.022 0 3.914.62 5.531 1.697A13.717 13.717 0 0014.665.273l-.052-.001C6.991.272.813 6.475.813 14.127",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.811.272H.813v27.71H23.81V.272z",
  fill: "url(#paint0_linear)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  maskUnits: "userSpaceOnUse",
  x: "10",
  y: "2",
  width: "19",
  height: "25"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.07 6.32c1.266-1.502 2.903-2.407 4.69-2.407 4.017 0 7.274 4.573 7.274 10.214 0 5.64-3.257 10.213-7.274 10.213-1.787 0-3.423-.905-4.69-2.405 1.98 2.58 4.923 4.217 8.21 4.217 2.021 0 3.913-.62 5.53-1.697a13.843 13.843 0 004.604-10.328c0-4.104-1.778-7.791-4.603-10.328C22.193 2.72 20.301 2.1 18.28 2.1c-3.287 0-6.23 1.637-8.21 4.218z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.414 2.101H10.07v24.051h18.344V2.102z",
  fill: "url(#paint1_linear)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "1.166",
  y1: ".724",
  x2: "1.166",
  y2: "27.578",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".3",
  stopColor: "#FF1B2D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".438",
  stopColor: "#FA1A2C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".594",
  stopColor: "#ED1528"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".758",
  stopColor: "#D60E21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".927",
  stopColor: "#B70519"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A70014"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: "10.181",
  y1: "2.378",
  x2: "10.181",
  y2: "26.124",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9C0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#FF4B4B"
}))));